import { render } from "./CalendarTab.vue?vue&type=template&id=0af3bc4c&scoped=true"
import script from "./CalendarTab.vue?vue&type=script&lang=js"
export * from "./CalendarTab.vue?vue&type=script&lang=js"

import "./CalendarTab.vue?vue&type=style&index=0&id=0af3bc4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af3bc4c"]])

export default __exports__